<script lang="ts">
	import { Tooltip } from "flowbite-svelte";
	import { getContext } from "svelte";
	import type { User } from "#gen/identities/v1/identities_pb.js";
	import Avatar from "#lib/components/Avatar.svelte";
	import type { Writable } from "svelte/store";

	interface Props {
		user?: User;
	}

	const localUser: Writable<User> = getContext("user");
	const id = `profile-${Math.random().toString(36).substring(7)}`;

	let { user }: Props = $props();

	function getCreatorName(): string {
		if ($localUser.id === user?.id) {
			return "You";
		}
		return user?.name ?? "";
	}
</script>

<div>
	{#if user?.photoUrl}
		<Avatar {id} src={user.photoUrl} alt={getCreatorName()} class="m-auto" referrerpolicy="no-referrer" />
	{:else}
		<Avatar {id} class="m-auto" />
	{/if}
	{#if user?.name}
		<Tooltip triggeredBy="#{id}" placement="bottom" class="z-10">{getCreatorName()}</Tooltip>
	{/if}
</div>
